import { FC, useMemo } from 'react';

import { cn } from 'utils/helpers';
import { Comment } from 'utils/types';

import ActivitiesEntry from './ActivitiesEntry';
import NotesEntry from './NotesEntry';
import TaskEntry from './TaskEntry';
import EventEntry from './EventEntry';
import EmailEntry from './EmailEntry';
// import MeetingEntry from './MeetingEntry';
// import LifecycleEntry from './LifecycleEntry';
// import CallEntry from './CallEntry';
// import ActivityEntry from './ActivityEntry';
// import TextEntry from './TextEntry';
// import TaskEntry from './TaskEntry';
// import EventEntry from './EventEntry';

// eslint-disable-next-line react-refresh/only-export-components
export enum ENTRY_TYPE {
  NOTES = 'NOTES',
  ACTIVITY = 'ACTIVITY',
  EMAIL = 'EMAIL',
  TASK = 'TASK',
  EVENT = 'EVENT',
}

interface PROPS {
  data: any;
  upComing?: boolean;
  open?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
  onEdit?: (id: string, value: Comment, referenceId: string) => void;
  className?: string;
  type: ENTRY_TYPE;
  isSelected?: boolean;
}

const Entry: FC<PROPS> = ({
  data,
  // upComing,
  // open,
  onClick,
  onDelete,
  onEdit,
  className,
  type,
  isSelected = false,
}) => {
  const defaultHandleOnDelete = () => null;
  const defaultHandleOnEdit = () => null;

  const element = useMemo(() => {
    switch (type) {
      case ENTRY_TYPE.EMAIL:
        return <EmailEntry onClick={onClick} data={data} />;
      // case 'meeting':
      //   return <MeetingEntry data={data} open={open} />;
      // case 'lifecycle':
      //   return <LifecycleEntry data={data} open={open} />;
      case ENTRY_TYPE.ACTIVITY:
        return <ActivitiesEntry data={data} />;
      // case 'text':
      //   return <TextEntry data={data} />;
      // case 'call':
      //   return <CallEntry data={data} open={open} />;
      // case 'task':
      //   return <TaskEntry data={data} open={open} />;
      // case 'event':
      //   return <EventEntry data={data} open={open} />;
      case ENTRY_TYPE.NOTES:
        return (
          <NotesEntry
            open={false}
            onDelete={onDelete ?? defaultHandleOnDelete}
            onEdit={onEdit ?? defaultHandleOnEdit}
            data={data}
          />
        );
      case ENTRY_TYPE.TASK:
        return <TaskEntry data={data} />;
      case ENTRY_TYPE.EVENT:
        return <EventEntry data={data} />;
      default:
        return null;
    }
  }, [data, onClick, onDelete, onEdit, type]);

  return (
    <div
      {...(onClick &&
        type !== ENTRY_TYPE.EMAIL && { onClick, role: 'button', tabIndex: 0 })}
      className={cn(
        'rounded-[6px]',
        type === ENTRY_TYPE.EMAIL ? 'bg-none' : 'bg-fill-secondary px-[22px]',
        'border border-separator-primary',
        'mb-[12px]',
        'text-sm text-secondary-base',
        // upComing ? 'border-[#C2F0E1]' : 'border-[#E6F0FF]',
        // upComing ? 'bg-[#EDFFF9]' : 'bg-fill-secondary',
        className,
        isSelected && 'border-primary-base',
      )}
    >
      {element}
    </div>
  );
};

export default Entry;
